export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_00.15c383f9.jpg";